<template>
    <b-modal :id="id" title="Confrim reject" centered>
        <div class="row">
            <div class="form-group col-12 col-md-12">
                <label for="rejectReason">
                    Reject reason
                </label>
                <textarea
                    id="rejectReason"
                    v-model="reason"
                    class="form-control"
                    type="text"
                    dir="rtl"
                />
            </div>
        </div>
        <template #modal-footer>
            <div class="col-12 d-flex justify-content-between">
                <button
                    type="button"
                    class="btn btn-danger waves-effect waves-light mr-2"
                    @click="close"
                >
                    Close
                </button>

                <button
                    type="button"
                    class="btn btn-success waves-effect waves-light mr-2"
                    @click="confirm"
                >
                    Confirm Reject
                </button>
            </div>
        </template>
    </b-modal>
</template>

<script>
export default {
    props: {
        id: {
            type: String,
            required: true
        }
    },

    data() {
        return {
            reason: ''
        };
    },

    methods: {
        close() {
            this.reason = '';
            this.$bvModal.hide(this.id);
        },

        confirm() {
            this.$emit('reject', this.reason);

            this.reason = '';
            this.$bvModal.hide(this.id);
        }
    }
};
</script>
